// @react/hooks/useAuthn.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { authnStore } from '@core/stores';

/**
 * React hook for SSOSession operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useAuthn } from '@react/hooks';
 *
 * const SSOSessionList = observer(() => {
 *   const store = useAuthn();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useAuthn() {
  return authnStore;
}
